<template>
    <v-container fluid class="page-shell history-page">
        <v-row justify="center" class="mx-0">
            <v-col cols="12" md="10" lg="9">
                <v-card class="history-card pa-4 pa-md-6" outlined>
                    <div v-if="isLoading" class="history-loading">Loading...</div>
                    <div v-else-if="historyPage && historyPage.description" class="history-content" v-html="historyPage.description" />
                    <div v-else class="history-empty">No history page found.</div>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import pageService from '@/services/page'

    export default {
        name: 'Page',
        data() {
            return {
                isLoading: true,
                historyPage: null
            }
        },
        created() {
            this.fetchHistoryPage()
        },
        methods: {
            normalizeText(value) {
                return String(value || '')
                    .trim()
                    .toLowerCase()
                    .normalize('NFD')
                    .replace(/[\u0300-\u036f]/g, '')
            },
            extractCollection(payload) {
                if (Array.isArray(payload)) {
                    return payload
                }

                if (!payload || typeof payload !== 'object') {
                    return []
                }

                const keys = ['data', 'items', 'rows', 'pages']
                for (const key of keys) {
                    if (Array.isArray(payload[key])) {
                        return payload[key]
                    }
                }

                if (payload.data && typeof payload.data === 'object') {
                    for (const key of keys) {
                        if (Array.isArray(payload.data[key])) {
                            return payload.data[key]
                        }
                    }
                }

                return []
            },
            fetchHistoryPage() {
                pageService.getPagesBySportId('', 1, 0)
                    .then(resp => {
                        const rows = this.extractCollection(resp && resp.data)
                        const history = rows.find(page => this.normalizeText(page && page.title) === 'history')
                        this.historyPage = history || null
                    })
                    .catch(() => {
                        this.historyPage = null
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            }
        }
    }
</script>

<style scoped>
    .history-card {
    background: rgba(255, 255, 255, 0.96);
    }

    .history-loading,
    .history-empty {
    color: #4b5970;
    font-weight: 600;
    }

    .history-content {
    color: #223152;
    line-height: 1.7;
    text-align: left;
    }
</style>

<style>
    .history-content,
    .history-content * {
    text-transform: none !important;
    }
</style>
